import React, { ReactNode } from 'react';
import { SerializedStyles, CSSObject } from '@core-ui/react-stitch';

type RailSectionProps = {
  children: ReactNode,
  // eslint-disable-next-line react/no-unused-prop-types
  position?: string,
  styles?: SerializedStyles | CSSObject
};

const RailSection = ({ children, styles }: RailSectionProps): JSX.Element => (
  <section css={styles || null}>
    {children}
  </section>
);

export default RailSection;
